import React from 'react'
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { bodyBoxstyle, bodyTitleStyle, listTypoStyle, titleStyle } from './coc-css'

const COCDialog = (props) => {
  return (
    <>
    <Dialog maxWidth='sm' fullWidth open={props.cocDialogStatus} onClose={() => props.updatecocDialogStatus}>
        <DialogTitle
            sx={{height: "1.8rem", padding: "0.4rem 0rem 0.4rem 1rem"  }}  
            style={titleStyle}
        >
            Code of Conduct
        </DialogTitle>
        <DialogContent>
        <Box style={bodyBoxstyle}>
        <Typography style={bodyTitleStyle}>
        WORKers are obliged to engage themselves in all kinds of General Compassion Acivities like
helping the needy, visit old-age homes, orphanages and hospitals, taking care of the widows and the
destitute and in doing so they have to make sure of the following:
        </Typography>
        <ul>
            <li>
                <Typography style={listTypoStyle}>
                    They will assure that they will be compassionate to their family members in general and to their 
                    parents and spouse in particular. 
                </Typography>
            </li>
            <li>
                <Typography style={listTypoStyle}>
                They will be compassionate to all human beings in general and to their neighbours in particulars.
                </Typography>
            </li>
        </ul>

    </Box>

        </DialogContent>

    </Dialog>
    
    </>
  )
}

export default COCDialog
